import { print } from "graphql";
import { BaseAPI } from "@/api/base.api";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { map } from "rxjs/operators";
import axios from "axios";
import Solicitacao from "@/models/solicitacao";

const solicitacaoArea = require("@/query/solicitacao/AreaSolicitacao.graphql");
const solicitacaoTipo = require("@/query/solicitacao/TipoSolicitacao.graphql");
const solicitacaoContatoForma = require("@/query/solicitacao/FormaContatoSolicitacao.graphql");

export class SolicitacaAPI extends BaseAPI<Solicitacao> {
  constructor() {
    super();
    this.apiUrl = `${this.apiUrl}/api/solicitacao`;
  }

  public solicitacaoAreas(): AxiosObservable<any> {
    return this.axios
      .post(`${this.graphqlUrl}`, {
        query: print(solicitacaoArea)
      })
      .pipe(
        map((data: any) => {
          const { listarAreas } = data;
          return listarAreas;
        })
      );
  }

  public solicitacaoTipos(): AxiosObservable<any> {
    return this.axios
      .post(`${this.graphqlUrl}`, {
        query: print(solicitacaoTipo)
      })
      .pipe(
        map((data: any) => {
          const { listarTiposSolicitacoes } = data;
          return listarTiposSolicitacoes;
        })
      );
  }

  public solicitacaoFormaContato(): AxiosObservable<any> {
    return this.axios
      .post(`${this.graphqlUrl}`, {
        query: print(solicitacaoContatoForma)
      })
      .pipe(
        map((data: any) => {
          const { listarFormasContato } = data;
          return listarFormasContato;
        })
      );
  }

  public solicitacaoFindByIdAndEmail(
    id: number,
    email: string,
    recaptcha: string
  ): AxiosObservable<any> {
    return this.axios.post(`${this.apiUrl}/findByIdAndEmail`, {
      id,
      email,
      recaptcha
    });
  }
}
